module.exports = __webpack_public_path__ + "media/newstyle/images/3000-outlets-es-50a227b1dbf73d1d3f225594d173a5a4.svg";